<div *ngIf="booking && shop">
  <a
    id="getDirectionsImage"
    type="button"
    class="href d-block"
    [href]="shop | mapsLink"
    target="_blank"
    angulartics2On="click"
    angularticsAction="ViewGoogleMapsBooking"
    [angularticsCategory]="booking.address.countryCode"
    [angularticsLabel]="booking.shopName"
  >
    <lh-image-slide [imageUrl]="imageUrl" [blurImages]="false" [showWatermark]="true" [fullWidth]="true">
    </lh-image-slide>
  </a>

  <!-- Close button -->
  <button type="button" class="close pull-right" aria-label="Close" (click)="close()">
    <svg viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  </button>

  <div class="modal-body" *ngIf="isInitialized">
    <p class="header">
      <span class="title">{{ shop.name }}</span>
      <span class="subtitle" *ngIf="showLocationType">{{ shop.locationType }}</span>
    </p>

    <div class="info-item">
      <a class="info-icon href" [href]="shop | mapsLink: false" target="_blank">
        <i class="icon-address"></i>
      </a>
      <div class="info-text">
        <div class="info-line bold">{{ shop.address | address }}</div>
        <div class="info-line directions" *ngIf="shop.directionsText">"{{ shop.directionsText }}"</div>
        <div class="info-line help" *ngIf="showHelpWithDirectionsCta">
          {{ 'TROUBLE_FINDING_LOCATION' | translate }}
          <a class="href" (click)="isHelpWithDirectionExpanded = true" *ngIf="!isHelpWithDirectionExpanded">{{
            'CONTACT' | translate
          }}</a>
          <a class="href" href="tel:{{ storageLocationTelephoneNumber }}" *ngIf="isHelpWithDirectionExpanded">{{
            storageLocationTelephoneNumber
          }}</a>
        </div>
      </div>
    </div>

    <div class="info-item">
      <div class="info-icon" (click)="toggleFullOpeningHours()">
        <i class="icon-hours"></i>
      </div>

      <div *ngIf="showSimpleOpeningHours" class="info-text" (click)="toggleFullOpeningHours()">
        <span class="info-line bold"
          >{{ booking.period.from | lhMoment: 'calendar' | uppercaseFirstLetter }}
          {{ getOpeningHoursFromDate(booking.period.from, shop) | timeInterval | async }}&nbsp;</span
        >

        <span class="info-line bold" *ngIf="isNotSameDay(booking.period.from, booking.period.to)"
          >{{ booking.period.to | lhMoment: 'calendar' | uppercaseFirstLetter }}
          {{ getOpeningHoursFromDate(booking.period.to, shop) | timeInterval | async }}</span
        >

        <div class="info-line">
          <a id="showFullOpeningHours" class="href" (click)="toggleFullOpeningHours()">{{ 'MORE' | translate }}</a>
        </div>
      </div>

      <div class="info-text" *ngIf="showFullOpeningHours">
        <div class="row">
          <div class="col col-4">{{ 'MONDAY' | translate }}</div>
          <div class="col col-8">{{ shop.openingHours.monday | timeInterval | async }}</div>

          <div class="col col-4">{{ 'TUESDAY' | translate }}</div>
          <div class="col col-8">{{ shop.openingHours.tuesday | timeInterval | async }}</div>

          <div class="col col-4">{{ 'WEDNESDAY' | translate }}</div>
          <div class="col col-8">{{ shop.openingHours.wednesday | timeInterval | async }}</div>

          <div class="col col-4">{{ 'THURSDAY' | translate }}</div>
          <div class="col col-8">{{ shop.openingHours.thursday | timeInterval | async }}</div>

          <div class="col col-4">{{ 'FRIDAY' | translate }}</div>
          <div class="col col-8">{{ shop.openingHours.friday | timeInterval | async }}</div>

          <div class="col col-4">{{ 'SATURDAY' | translate }}</div>
          <div class="col col-8">{{ shop.openingHours.saturday | timeInterval | async }}</div>

          <div class="col col-4">{{ 'SUNDAY' | translate }}</div>
          <div class="col col-8">{{ shop.openingHours.sunday | timeInterval | async }}</div>

          <div class="col col-12">
            <a id="hideFullOpeningHours" class="href" (click)="toggleFullOpeningHours()">{{ 'LESS' | translate }}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="action-buttons">
      <a
        id="viewInGoogleMaps"
        type="button"
        class="btn btn-primary"
        width="50%"
        [href]="shop | mapsLink: true"
        target="_blank"
        angulartics2On="click"
        angularticsAction="ViewGoogleMapsBooking"
        [angularticsCategory]="booking.address.countryCode"
        [angularticsLabel]="booking.shopName"
      >
        {{ 'GET_DIRECTIONS' | translate }}
      </a>

      <a
        id="viewInGoogleMaps"
        type="button"
        class="btn btn-info"
        width="50%"
        [href]="shop | mapsLink: false"
        target="_blank"
        angulartics2On="click"
        angularticsAction="ViewGoogleMapsBooking"
        [angularticsCategory]="booking.address.countryCode"
        [angularticsLabel]="booking.shopName"
      >
        {{ 'VIEW_IN_MAPS' | translate }}
      </a>
    </div>
  </div>
</div>
